import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedTaxRateSelector($companyId: ID!, $id: ID) {
    taxRates(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
      }
    }
  }
`

export const Query = gql`
  query TaxRateSelector(
    $companyId: ID!,
    $filters: TaxRateFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    taxRates(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
